'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'add',
  aliases: ['create'],
  colors: [],
  path: _react2.default.createElement('path', {
    unicode: '\uF067',
    glyphName: 'plus',
    transform: 'scale(1,-1) translate(0, -1408)',
    horizAdvX: '1408',
    d: 'M1408 800v-192q0 -40 -28 -68t-68 -28h-416v-416q0 -40 -28 -68t-68 -28h-192q-40 0 -68 28t-28 68v416h-416q-40 0 -68 28t-28 68v192q0 40 28 68t68 28h416v416q0 40 28 68t68 28h192q40 0 68 -28t28 -68v-416h416q40 0 68 -28t28 -68z'
  }),
  viewBox: '0 0 1536 1408'
};


//////////////////
// WEBPACK FOOTER
// ./~/tanda-components/Icon/svgs/add.js
// module id = 1585
// module chunks = 0